var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CheckListComponent',{attrs:{"typeName":"品質巡回 点検一覧","type":1,"claim":false,"settionStrageName":"CheckListStorageItemName"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }